module.exports = __webpack_public_path__ + "images/emoji/house_with_garden.822b65e93ed13103488e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/house_with_garden.png
// module id = wwm6
// module chunks = 24